import {
  OwnUpDefaultErrorNotification,
  OwnUpSmallBodyMedium,
  OwnUpSmallSubheadlineMedium,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

import { useDownPayment } from '../../data/dataProvider';

const SummaryContainer = styled.div`
  display: flex;

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    column-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(8)}px;
  }
`;

const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1)}px;

  flex-basis: 50%;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    flex-basis: auto;
  }
`;

const ResultValue = styled(OwnUpSmallSubheadlineMedium)`
  padding-top: 0 !important;
`;

const formatCurrency = (number: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(number);

const displayNumber = (number?: number) =>
  typeof number === 'number' && !Number.isNaN(number) ? formatCurrency(number) : '-';

export const SummaryArticle = () => {
  const { getHomePrice, getMonthlyPayment } = useDownPayment();
  const error = null;

  return (
    <>
      {error ? (
        <>
          <OwnUpDefaultErrorNotification $hasIcon={true} title="Error" description={error} />
        </>
      ) : (
        <SummaryContainer>
          <SummaryItem>
            <ResultValue variant="h2">{displayNumber(getHomePrice())}</ResultValue>
            <OwnUpSmallBodyMedium variant="body1">Home price</OwnUpSmallBodyMedium>
          </SummaryItem>
          <SummaryItem>
            <ResultValue variant="h2">{displayNumber(getMonthlyPayment())}</ResultValue>
            <OwnUpSmallBodyMedium variant="body1">Monthly payment</OwnUpSmallBodyMedium>
          </SummaryItem>
        </SummaryContainer>
      )}
    </>
  );
};
